import React from "react";
import { useQuery } from "@tanstack/react-query";
import MetricsGrid from "../components/dashboard/metrics-grid";
import ActiveVisits from "../components/dashboard/active-visits";
import SystemStatus from "../components/dashboard/system-status";
import { api } from "../lib/api";

export default function Dashboard() {
  const { data: metrics, isLoading: metricsLoading } = useQuery({
    queryKey: ["/api/dashboard/metrics"],
    queryFn: api.getDashboardMetrics,
    refetchInterval: 30000, // Refresh every 30 seconds
  });

  const { data: activeVisits, isLoading: visitsLoading } = useQuery({
    queryKey: ["/api/dashboard/active-visits", 50, 0], //  to limit 50, offset 0
    queryFn: () => api.getActiveVisits(50, 0),
    refetchInterval: 10000, // Refresh every 10 seconds
  });

  return (
    <div className="p-6 space-y-6">
          {/* Metrics Grid */}
          <MetricsGrid metrics={metrics} isLoading={metricsLoading} />

          {/* Main Dashboard Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <ActiveVisits visits={activeVisits} isLoading={visitsLoading} />
            <SystemStatus />
          </div>

          {/* Recent Activity */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Recent Sessions */}
            <div className="bg-card rounded-xl border border-border shadow-sm">
              <div className="p-6 border-b border-border">
                <h3 className="text-lg font-semibold text-foreground">Recent Sessions</h3>
              </div>
              
              <div className="p-6 space-y-4">
                <div className="text-center text-muted-foreground py-8">
                  No recent sessions to display
                </div>
              </div>
            </div>

            {/* Activity Feed */}
            <div className="bg-card rounded-xl border border-border shadow-sm">
              <div className="p-6 border-b border-border">
                <h3 className="text-lg font-semibold text-foreground">Activity Feed</h3>
              </div>
              
              <div className="p-6 space-y-4">
                <div className="text-center text-muted-foreground py-8">
                  No recent activity to display
                </div>
              </div>
            </div>
          </div>
    </div>
  );
}
